import PDFIcon from "../../Images/pdfIcon.png";

const PressRelease = () => {
  const documents = [
    {
      title: "Voting Result with Scrutinizer Report 2026",
      buttonLabel: "View Press Release",
      fileName: "Voting-result-with-Scrutinizer-report-2026.pdf",
    },
    {
      title: "Press Release - DE SENS COLDSTORE",
      buttonLabel: "View Press Release",
      fileName: "Press-Release_DE-SENS-COLDSTORE.pdf",
    },
    {
      title: "Press Release - Peeling Capacity",
      buttonLabel: "View Press Release",
      fileName: "Press Relesase peeling capacity.pdf",
    },
    {
      title: "Press Release - Operational and Financial Performance",
      buttonLabel: "View Press Release",
      fileName: "press release 15052026.pdf",
    },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
              <h2 className="site-title">
                Press <span>Release</span>
              </h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.map((doc, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item p-3">
                <img src={PDFIcon} alt="pdf icon" />
                <div className="team-content">
                  <div className="team-bio">
                    <h5>{doc.title}</h5>
                    <a
                      className="theme-btn mt-2"
                      href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.buttonLabel}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PressRelease;
